import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { BETSLIP_NOTIFICATION_VIEWS } from 'configs/betslip';
import { MIN_COMBINATION_PRICES } from 'configs/products';
import { connect } from 'react-redux';
import { showModal } from 'common/actions/uiActions';
import betSlipSelector, {
    checkMaximumPicks,
    checkMinimumPicks,
} from 'common/selectors/betSlipSelector';
import NotificationConductor from 'common/conductors/NotificationConductor';
import combinationsCountSelector from 'common/selectors/combinationsCountSelector';
import {
    getMultitrackCodes,
    getTrackFromRacingCard,
} from 'common/selectors/trackSelector';
import raceDaySelector from 'common/selectors/raceDaySelector';
import { isMultitrackProduct } from 'common/selectors/multipleTrackSetupsSelector';
import { setDerbyLynBet, setSmartLynBet } from 'features/BetSlipState/actions';

import getTexts from 'utils/localization';
const t = getTexts();

class BetslipNotifier extends Component {
    validateBettingSelection = () => {
        const { maximumPicksValid, showBetslipPopup } = this.props;

        maximumPicksValid && showBetslipPopup();

        !maximumPicksValid &&
            NotificationConductor.error(t.betSlip.maximumPicksError);
    };

    render() {
        const { selectedProduct, combinationsCount: count } = this.props;

        if (!selectedProduct) {
            return null;
        }

        const productId = selectedProduct.id;

        // if (count === 0) {
        //     return null;
        // }

        if (!BETSLIP_NOTIFICATION_VIEWS[productId]) {
            throw new Error(
                `No notification view component specified for product ${productId}`
            );
        }

        const NotificationComponent = BETSLIP_NOTIFICATION_VIEWS[productId];

        return (
            <div
                style={{ visibility: count === 0 ? 'hidden' : 'visible' }}
                onClick={this.validateBettingSelection}
            >
                <NotificationComponent
                    combinationsCount={count}
                    basicPrice={
                        this.props.selectedProduct
                            ? MIN_COMBINATION_PRICES[
                                  this.props.selectedProduct.id
                              ]
                            : 0
                    }
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    date: raceDaySelector(state).date,
    trackCode: getTrackFromRacingCard(state).code,
    selectedProduct: state.AISDataProvider.selectedProduct,
    combinationsCount: combinationsCountSelector(state),
    betSlip: betSlipSelector(state),
    multitrackCodes: getMultitrackCodes(state),
    isMultitrack: isMultitrackProduct(state),
    minimumPicksValid: checkMinimumPicks(state),
    maximumPicksValid: checkMaximumPicks(state),
    smartLynMode: state.BetSlip.smartLynMode,
    derbyLynBet: state.BetSlip.derbyLynBet,
    races: state.AISDataProvider.racingCardData.races,
    auth: state.auth,
    serverTime: state.AISDataProvider.serverTime,
});

const mapDispatchToProps = (dispatch) => {
    return {
        showBetslipPopup: () => {
            dispatch(showModal('BET_SLIP', 101));
        },
        showQuickPickAmountModal: (data) => {
            dispatch(showModal('QUICK_PICK_AMOUNT', -896, data));
        },
        setSmartLynBet: (smartLynBet) => {
            dispatch(setSmartLynBet(smartLynBet));
        },
        setDerbyLynBet: (date, trackCode, product) => {
            dispatch(setDerbyLynBet(date, trackCode, product));
        },
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(BetslipNotifier)
);
